module.exports = __webpack_public_path__ + "static/media/mp.5003263a.webp";